import { Component, OnInit, Input, ElementRef, OnChanges, HostListener, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { empty } from 'rxjs/internal/observable/empty';

@Component({
  selector: 'app-catalogs-preparation-info-card',
  templateUrl: './catalogs-preparation-info-card.component.html',
  styleUrls: ['./catalogs-preparation-info-card.component.scss']
})
export class CatalogsPreparationInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() preparation;
  editingLocked;
  updatePreparationInfoSubcription: Subscription;
  basicDataForm = new FormGroup({
    active: new FormControl({ value: null, disabled: true }),
    name: new FormControl({ value: null, disabled: true }, Validators.required),
    code: new FormControl({ value: null, disabled: true }, Validators.required)
  });
  updatePreparationInfoSubscription: Subscription;

  constructor(private preparationsService: PreparationsService,
              private snackbarService: SnackBarService,
              private eRef: ElementRef) {
                this.editingLocked = true;
              }

  ngOnInit() { }

  ngOnChanges() {
    if (this.preparation) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.preparation && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
        this.lockEdition();
      }
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updatePreparationInfoSubscription = this.preparationsService.updatePreparationInfo(this.preparation.InternalId, this.basicDataForm).pipe(
        tap(o => this.editingLocked = true),
        tap(o => this.snackbarService.open('catalogs-page.snackbar messages.update preparation success', 'success')),
        tap(o => this.preparationsService.refreshPreparation()),
        catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
      ).subscribe();
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'catalogs-page.snackbar messages.name preparations error';
    } else if (!this.basicDataForm.get('code').valid) {
      return 'catalogs-page.snackbar messages.code preparations error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.preparation.Active,
      name: this.preparation.Description,
      code: this.preparation.Code
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('name').enable();
    this.basicDataForm.get('code').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('name').disable();
    this.basicDataForm.get('code').disable();
    this.editingLocked = true;
  }

  ngOnDestroy() {
    if (this.updatePreparationInfoSubscription) { this.updatePreparationInfoSubscription.unsubscribe(); }
  }
}
